import { MLSListing } from '@aloft/toolkit-shared';

import { MLSDataColumn } from './MLSDataColumn.tsx';
import { MLSDataInfoSection } from './MLSDataInfoSection.tsx';
import { MLSDataValueWithLabel } from './MLSDataValueWithLabel.tsx';

export const MLSSchoolInfo = ({ listingData }: { listingData: MLSListing }) => (
  <MLSDataInfoSection title="Schools" spanColumns>
    <MLSDataColumn>
      <MLSDataValueWithLabel value={listingData.SchoolDistrict} label="School Disctrict" />
      <MLSDataValueWithLabel value={listingData.ElementarySchool} label="Elementary" />
      <MLSDataValueWithLabel value={listingData.HighSchool} label="High School" />
      <MLSDataValueWithLabel value={listingData.MiddleOrJuniorSchool} label="Junior High School" />
    </MLSDataColumn>
  </MLSDataInfoSection>
);
